var render = function render(){var _vm=this,_c=_vm._self._c;return _c('card',{directives:[{name:"show",rawName:"v-show",value:(_vm.loading),expression:"loading"}],staticClass:"download-widget",attrs:{"dis-hover":""}},[_c('spin',{attrs:{"size":"large"}}),_c('div',{staticClass:"download-widget__title ms-text"},[_vm._v("\n    Идет скачивание документов... ("+_vm._s(_vm.loaded)+" МБ)\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }